import classNames from "classnames";
import styles from "./divider.module.scss";

type Props = {
  className?: string;
  width?: number;
};

export default function HorizontalDivider({ className, width = 100 }: Props) {
  return (
    <div
      style={{ width: `${width}%` }}
      className={classNames(styles.divider, className)}
    />
  );
}
